import {
    error,
    finish
} from '../../../modules/related-contingency/actions/get-markets-for-rc-tag';
import api from '../../../api';

export function request(dispatch, {
    tagId,
    query
}) {
    api.post(`/contingencies/tag-content/${tagId}`, query).then(res => {
        dispatch(finish(res));
    }).catch(err => {
        dispatch(error(err));
    });
}
